import { cache } from "../../../apollo/provider";
import { SurfaceType } from "../../../gql-generated/types";
import { type GetLensQuery, getLens } from "../../../lens/api/queries";

const RAW_SURFACE_TYPE_SNAPCHAT = "SURFACE_TYPE_SNAPCHAT";
const RAW_SURFACE_TYPE_SPECTACLES = "SURFACE_TYPE_SPECTACLES";

// Needed to convert the type from search string to SurfaceType
const stringToSurfaceType = (rawStringType: string): SurfaceType => {
    switch (rawStringType) {
        case RAW_SURFACE_TYPE_SNAPCHAT:
            return SurfaceType.SurfaceTypeSnapchat;
        case RAW_SURFACE_TYPE_SPECTACLES:
            return SurfaceType.SurfaceTypeSpectacles;
        default:
            return SurfaceType.SurfaceTypeUnset;
    }
};

export const formatSurfaceTypeFromSearch = (search: string | null): SurfaceType[] | null => {
    if (search === null) {
        return null;
    }
    return search.split(",").map((type) => stringToSurfaceType(type));
};

/**
 * @description Handles updating the surfaceType field in the Lens cache. Needed on the Successful submission page and
 * when navigating from Successful submission page to Lens Details due to stale data on Lens Central.
 */
export const surfaceTypeCacheModify = (lensId: string, surfaceTypeFromSearch: string | null): void => {
    const formattedSurfaceType = formatSurfaceTypeFromSearch(surfaceTypeFromSearch);

    cache.updateQuery<GetLensQuery>({ query: getLens, variables: { lensId } }, (data) => {
        if (!data || !data.getLens.lens) {
            return data;
        }

        return {
            ...data,
            getLens: {
                ...data.getLens,
                lens: {
                    ...data.getLens.lens,
                    surfaceType: formattedSurfaceType ?? data.getLens.lens.surfaceType,
                },
            },
        };
    });
};
